import { tokenLogos } from '@/config/chain/configs/mainnet/assets'
import { assets } from '@/ui/assets'

export const LINKS_DATA = {
  savings: {
    label: 'Savings',
    icon: <img src={assets.page.savings} alt="Savings icon" className="h-4 w-4" />,
  },
  sparkLend: {
    label: 'SparkLend',
    icon: <img src={assets.page.sparkLend} alt="SparkLend icon" className="h-5 w-5" />,
  },
  sparkToken: {
    label: 'SPK',
    icon: <img src={tokenLogos.spk} alt="Spark token icon" className="h-5 w-5" />,
  },
  swap: {
    label: 'Swap',
    icon: <img src={assets.page.swap} alt="Swap icon" className="h-5 w-5" />,
  },
}
